import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef } from 'vue';

type AnimationType = 'bubbles' | 'bar' | 'infinity';

interface Props {
  animationType?: AnimationType;
  duration?: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingAnimation',
  props: {
    animationType: { default: 'bar' },
    duration: { default: 3 }
  },
  setup(__props: any) {

const props = __props as { animationType: AnimationType, duration: number }



const path: string =
  `M61.4504 25.9577L43.815 8.32233C34.0205 -1.44078 18.1404 -1.44078 8.3459 8.32233
  C-1.44863 18.0854 -1.44863 33.9146 8.3459 43.6777C18.1404 53.4408 34.0205 53.4408 
  43.815 43.6777L61.4504 26L79.185 8.32233C88.9795 -1.44078 104.86 -1.44078 114.654 
  8.32233C124.449 18.0854 124.449 33.9146 114.654 43.6777C104.86 53.4408 88.9795 53.4408 79.185 43.6777
  L61.5073 26`;

const cssVars: ComputedRef<Record<string, string | undefined>> = computed(() => {
  return {
    '--duration': `${props.duration}s`,
  };
});

return { __sfc: true,props, path, cssVars }
}

})